import React from 'react';

export const Description = ({ item }) => {
  const description = (el: { text_2: string }) =>
    el && el.text_2 ? el.text_2.substring(0, 1000) : '';

  if ('highlight_text_2' in item) {
    return item.highlight_text_2.map((e, i) => (
      <div
        key={i}
        className="description highlight_description"
        dangerouslySetInnerHTML={{
          __html: `...${description({ text_2: e })}`
        }}
      />
    ));
  }

  return <p className="description">{description(item)}</p>;
};
